// eslint-disable-next-line import/prefer-default-export
export enum WatermarkPosition {
  BOTTOM_RIGHT = "BOTTOM_RIGHT",
  BOTTOM_LEFT = "BOTTOM_LEFT",
  UPPER_RIGHT = "UPPER_RIGHT",
  UPPER_LEFT = "UPPER_LEFT",
  RANDOM = "RANDOM",
}

export enum WatermarkType {
  IMAGE = "IMAGE",
  USER_ID = "USERID",
}
